export var AiOutput;
(function (AiOutput) {
    AiOutput["AI_BLOCK"] = "ai_block";
    AiOutput["GENERATED_BLOCKS"] = "generated_blocks";
    AiOutput["BOTH"] = "both";
})(AiOutput || (AiOutput = {}));
export var FieldKey;
(function (FieldKey) {
    FieldKey["BACKGROUND_EFFECT"] = "backgroundEffect";
    FieldKey["FOREGROUND_EFFECT"] = "foregroundEffect";
    FieldKey["BACKGROUND_PALETTE"] = "backgroundColor";
})(FieldKey || (FieldKey = {}));
